import { render, staticRenderFns } from "./publishArea.vue?vue&type=template&id=25799ae0&scoped=true&"
import script from "./publishArea.vue?vue&type=script&lang=js&"
export * from "./publishArea.vue?vue&type=script&lang=js&"
import style0 from "./publishArea.vue?vue&type=style&index=0&id=25799ae0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25799ae0",
  null
  
)

export default component.exports